// import React, { useState, useEffect } from 'react';
// import './Sidebar.scss';
// import { Link, useLocation } from 'react-router-dom';
// import { IoIosArrowDown } from "react-icons/io";
// import Cookies from "js-cookie";
// import { useDispatch, useSelector } from "react-redux";
// import { logout, setUser, setPermissions } from "../redux/features/authSlice";
// import { useNavigate } from "react-router-dom";
// import { FaBuilding } from 'react-icons/fa';
// import { getAdminProfile } from "../redux/services/authService/authApi";
// import { RiCloseLine } from "react-icons/ri";

// import {
//   MdDashboard,
//   MdBusinessCenter,
//   MdPeople,
//   MdCampaign,
//   MdReport,
//   MdSettings,
//   MdLogout,
//   MdSports,
//   MdApartment,
// } from "react-icons/md";

// import logo from '../assets/image/logo.jpeg';

// const Sidebar = ({ isOpen, onToggleSidebar }) => {
//   const location = useLocation();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const user = useSelector((state) => state.auth.user);
//   const userPermissions = useSelector((state) => state.auth.permissions || []);
//   const token = Cookies.get("adminToken");

//   const [isLoadingProfile, setIsLoadingProfile] = useState(false);
//   const [activeDropdown, setActiveDropdown] = useState(null);
//   const [activeMenu, setActiveMenu] = useState(() => {
//     return localStorage.getItem("activeMenu") || "";
//   });

//   // Check if it's mobile/tablet view
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 992);
//     };
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   // Fetch profile if needed
//   useEffect(() => {
//     const fetchProfile = async () => {
//       if (user || !token) return;

//       try {
//         setIsLoadingProfile(true);
//         const response = await getAdminProfile();

//         if (response.success === 1 && response.data) {
//           const userData = response.data;

//           dispatch(setUser({
//             id: userData.id,
//             name: userData.name,
//             email: userData.email,
//             mobile: userData.mobile,
//             role: userData.role || 'sub_admin',
//             waad_id: userData.waad_id,
//             waad_name: userData.waad_name,
//             status: userData.status,
//           }));

//           if (userData.permissions) {
//             dispatch(setPermissions(userData.permissions));
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching profile:", error);
//         const tokenUser = getUserFromToken();
//         if (tokenUser) {
//           dispatch(setUser({
//             id: tokenUser.id,
//             email: tokenUser.email,
//             role: tokenUser.role || 'sub_admin',
//             waad_id: tokenUser.waad_id,
//             waad_name: tokenUser.waad_name,
//             name: tokenUser.name || "Admin",
//           }));
//         }
//       } finally {
//         setIsLoadingProfile(false);
//       }
//     };

//     fetchProfile();
//   }, [token, dispatch, user]);

//   const getUserFromToken = () => {
//     if (!token) return null;
//     try {
//       const decoded = JSON.parse(atob(token.split(".")[1]));
//       return {
//         id: decoded.id,
//         email: decoded.email,
//         role: decoded.role || 'sub_admin',
//         waad_id: decoded.waad_id,
//         waad_name: decoded.waad_name,
//         name: decoded.name || "Admin",
//       };
//     } catch (err) {
//       return null;
//     }
//   };

//   const getUserRole = () => {
//     if (user?.role) return user.role;
//     const tokenUser = getUserFromToken();
//     return tokenUser?.role || 'sub_admin';
//   };

//   const userRole = getUserRole();

//   const hasViewPermission = (permissionKey) => {
//     if (userRole === 'admin') return true;
//     if (userRole === 'sub_admin') {
//       return userPermissions.some(
//         (p) => p.permission_key === permissionKey && p.can_view === 1
//       );
//     }
//     return false;
//   };

//   const hasChildViewPermission = (children) => {
//     if (!children?.length) return false;
//     return children.some((child) => hasViewPermission(child.permission));
//   };

//   const menuItems = [
//     {
//       items: [
//         {
//           id: 'dashboard',
//           title: 'Dashboard',
//           href: '/',
//           icon: <MdDashboard />,
//           permission: 'dashboard',
//         },
//         {
//           id: 'admin-management',
//           title: 'Admin Management',
//           dropdown: true,
//           icon: <MdBusinessCenter />,
//           children: [
//             {
//               id: 'admin-list',
//               title: 'Admin List',
//               href: '/admin-list',
//               permission: 'admin_list',
//             },
//           ],
//         },
//         {
//           id: 'master-management',
//           title: 'Master Management',
//           dropdown: true,
//           icon: <MdPeople />,
//           children: [
//             { id: 'gotra', title: 'Gotra', href: '/gotra-list', permission: 'gotra_list' },
//             { id: 'nanihal-gotra', title: 'Nanihal Gotra', href: '/nanihal-gotra', permission: 'nanihal_gotra_list' },
//             { id: 'kuldevi', title: 'Kuldevi', href: '/kuldevi', permission: 'kuldevi_list' },
//             { id: 'education', title: 'Education', href: '/education', permission: 'education_list' },
//             { id: 'occupation', title: 'Occupation', href: '/occupation', permission: 'occupation_list' },
//             { id: 'waad', title: 'Waad List', href: '/waad', permission: 'waad_list' },
//             { id: 'gaon', title: 'Gaon List', href: '/gaon', permission: 'gaon_list' },
//           ],
//         },
//         {
//           id: "familymanagement",
//           title: "Pariwar Management",
//           dropdown: true,
//           icon: <MdPeople />,
//           children: [
//             { id: "pendingPariwar", title: "Pending Pariwar", href: "/pariwar-pending", permission: 'pariwar_pending' },
//             { id: "approvedPariwar", title: "Approved Pariwar", href: "/pariwar-success", permission: 'pariwar_approved' },
//             { id: "rejectedPariwar", title: "Rejected Pariwar", href: "/pariwar-rejected", permission: 'pariwar_rejected' },
//           ],
//         },
//         {
//           id: "mamberymanagement",
//           title: "Sadasya Management",
//           dropdown: true,
//           icon: <MdPeople />,
//           children: [
//             { id: "pendingSadasya", title: "Pending Sadasya", href: "/sadasya-pending", permission: 'sadasya_pending' },
//             { id: "approvedSadasya", title: "Approved Sadasya", href: "/sadasya-success", permission: 'sadasya_approved' },
//             { id: "rejectedSadasya", title: "Rejected Sadasya", href: "/sadasya-rejected", permission: 'sadasya_rejected' },
//           ],
//         },
//         {
//           id: 'building-management',
//           title: 'Building Management',
//           dropdown: true,
//           icon: <FaBuilding />,
//           children: [
//             { id: 'all-buildings', title: 'All Buildings', href: '/admin/buildings', permission: 'building_list' },
//             { id: 'all-bookings', title: 'All Bookings', href: '/admin/bookings', permission: 'booking_list' },
//           ],
//         },
//         {
//           id: 'education-sco',
//           title: 'Scholarships',
//           href: '/admin/education',
//           icon: <MdCampaign />,
//           permission: 'scholarship_list',
//         },
//         {
//           id: 'eventmanagement',
//           title: 'Event Management',
//           href: '/events',
//           icon: <MdCampaign />,
//           permission: 'event_list',
//         },
//         {
//           id: 'newsmanagement',
//           title: 'News Management',
//           href: '/news',
//           icon: <MdCampaign />,
//           permission: 'news_list',
//         },
//         {
//           id: 'helpdesk',
//           title: 'Helpdesk',
//           href: '/helpdesk',
//           icon: <MdReport />,
//           permission: 'helpdesk_list',
//         },
//         {
//           id: 'employment',
//           title: 'Employment',
//           href: '/employment',
//           icon: <MdReport />,
//           permission: 'employment_list',
//         },
//         {
//           id: 'selections',
//           title: 'Selections',
//           href: '/selections',
//           icon: <MdSports />,
//           permission: 'selections_list',
//         },
//         {
//           id: 'content-setting',
//           title: 'Content / Setting',
//           href: '/web-setting',
//           icon: <MdSettings />,
//           permission: 'settings_view',
//         },
//         {
//           id: 'banner',
//           title: 'Banner',
//           href: '/banner-list',
//           icon: <MdSettings />,
//           permission: 'banner_list',
//         },
//         {
//           id: 'logout',
//           title: 'Logout',
//           action: "logout",
//           icon: <MdLogout />,
//         },
//       ],
//     },
//   ];

//   const getFilteredMenuItems = () => {
//     return menuItems.map((section) => ({
//       ...section,
//       items: section.items.filter((item) => {
//         if (item.action === 'logout') return true;
//         if (item.href) return hasViewPermission(item.permission);
//         if (item.dropdown && item.children) return hasChildViewPermission(item.children);
//         return true;
//       }),
//     }));
//   };

//   const filteredMenuItems = getFilteredMenuItems();

//   const handleLogout = () => {
//     Cookies.remove("adminToken");
//     dispatch(logout());
//     navigate("/login");
//     if (isMobile && isOpen) {
//       onToggleSidebar();
//     }
//   };

//   // Keep active menu + open correct dropdown on route change
//   useEffect(() => {
//     filteredMenuItems.forEach((section) => {
//       section.items.forEach((item) => {
//         if (item.href === location.pathname) {
//           setActiveMenu(item.id);
//           setActiveDropdown(null);
//           localStorage.setItem("activeMenu", item.id);
//         }

//         if (item.children) {
//           item.children.forEach((child) => {
//             if (child.href === location.pathname) {
//               setActiveMenu(child.id);
//               setActiveDropdown(item.id);
//               localStorage.setItem("activeMenu", child.id);
//             }
//           });
//         }
//       });
//     });
//   }, [location.pathname]);

//   const toggleDropdown = (dropdownId) => {
//     // Simple toggle - if same dropdown, close it; if different, open it
//     if (activeDropdown === dropdownId) {
//       setActiveDropdown(null);
//     } else {
//       setActiveDropdown(dropdownId);
//     }
//   };

//   const goTo = (id, href) => {
//     setActiveMenu(id);
//     localStorage.setItem("activeMenu", id);
//     navigate(href);
    
//     // Close sidebar on mobile after navigation
//     if (isMobile && isOpen) {
//       setTimeout(() => {
//         onToggleSidebar();
//       }, 200);
//     }
//   };

//   const renderMenuItem = (item) => {
//     // Logout
//     if (item.action === "logout") {
//       return (
//         <li key={item.id} className={`menu-item ${activeMenu === item.id ? "active" : ""}`}>
//           <div className="menu-link" onClick={handleLogout}>
//             {item.icon && <span className="menu-icon">{item.icon}</span>}
//             <span className="menu-text">{item.title}</span>
//           </div>
//           <div className="sidebar-tooltip">
//             <div className="tooltip-content">
//               <strong>{item.title}</strong>
//             </div>
//           </div>
//         </li>
//       );
//     }

//     const isDropdownOpen = activeDropdown === item.id;
//     const isActive = activeMenu === item.id ||
//       (item.children && item.children.some((c) => c.id === activeMenu));

//     return (
//       <li
//         key={item.id}
//         className={`menu-item ${isActive ? "active" : ""} ${item.dropdown ? "has-dropdown" : ""}`}
//       >
//         {item.dropdown ? (
//           <div
//             className={`menu-link ${isActive ? "active" : ""}`}
//             onClick={() => toggleDropdown(item.id)}
//           >
//             {item.icon && <span className="menu-icon">{item.icon}</span>}
//             <span className="menu-text">{item.title}</span>
//             <span className={`menu-arrow ${isDropdownOpen ? "rotate" : ""}`}>
//               <IoIosArrowDown />
//             </span>
//           </div>
//         ) : (
//           <div
//             className={`menu-link ${activeMenu === item.id ? "active" : ""}`}
//             onClick={() => goTo(item.id, item.href)}
//           >
//             {item.icon && <span className="menu-icon">{item.icon}</span>}
//             <span className="menu-text">{item.title}</span>
//           </div>
//         )}

//         {/* Hover tooltip */}
//         <div className="sidebar-tooltip">
//           <div className="tooltip-content">
//             <strong>{item.title}</strong>
//             {item.dropdown && (
//               <ul className="tooltip-menu">
//                 {item.children
//                   .filter((child) => userRole === 'admin' || hasViewPermission(child.permission))
//                   .map((child) => (
//                     <li key={child.id} onClick={() => {
//                       goTo(child.id, child.href);
//                     }}>
//                       {child.title}
//                     </li>
//                   ))}
//               </ul>
//             )}
//           </div>
//         </div>

//         {/* Inline submenu - always show when dropdown is open */}
//         {item.dropdown && isDropdownOpen && (
//           <div className="collapse show">
//             <ul className="sub-menu">
//               {item.children.map((child) => {
//                 if (userRole === 'sub_admin' && !hasViewPermission(child.permission)) {
//                   return null;
//                 }
//                 return (
//                   <li key={child.id} className={`menu-item ${activeMenu === child.id ? "active" : ""}`}>
//                     <div
//                       className={`menu-link ${activeMenu === child.id ? "active" : ""}`}
//                       onClick={() => {
//                         setActiveMenu(child.id);
//                         localStorage.setItem("activeMenu", child.id);
//                         navigate(child.href);
//                         if (isMobile && isOpen) {
//                           setTimeout(() => {
//                             onToggleSidebar();
//                           }, 200);
//                         }
//                       }}
//                     >
//                       <span className="menu-text">{child.title}</span>
//                     </div>
//                   </li>
//                 );
//               })}
//             </ul>
//           </div>
//         )}
//       </li>
//     );
//   };

//   if (isLoadingProfile) {
//     return (
//       <div className={`sidebar ${!isOpen ? 'closed' : ''}`}>
//         <div className={`main-menu ${isOpen ? '' : 'collapsed'}`}>
//           <div className="logo-box">
//             <Link className="logo-link" to="/">
//               <img src={logo} alt="logo" className="logo-full" height="40" />
//               <MdApartment className="logo-icon" />
//             </Link>
//           </div>
//           <div className="sidebar-content text-center py-5">
//             <div className="spinner-border text-primary" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </div>
//             <p className="mt-2 text-muted">Loading profile...</p>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className={`sidebar ${!isOpen ? 'closed' : ''}`}>
//       {!isOpen && <div className="overlaysidebar" onClick={onToggleSidebar}></div>}
//       <div className={`main-menu ${isOpen ? '' : 'collapsed'}`}>
//         <button
//           className="overlay-close-btn"
//           onClick={(e) => {
//             e.stopPropagation();
//             onToggleSidebar();
//           }}
//         >
//           <RiCloseLine />
//         </button>
//         <div className="logo-box">
//           <Link className="logo-link" to="/" onClick={() => {
//             if (isMobile && isOpen) {
//               onToggleSidebar();
//             }
//           }}>
//             <img src={logo} alt="logo" className="logo-full" height="40" />
//             <MdApartment className="logo-icon" />
//           </Link>
//         </div>

//         <div className="sidebar-content">
//           <ul className="app-menu">
//             {filteredMenuItems.map((section, index) => (
//               <React.Fragment key={index}>
//                 {section.items.map((item) => renderMenuItem(item))}
//               </React.Fragment>
//             ))}
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Sidebar;
import React, { useState, useEffect } from 'react';
import './Sidebar.scss';
import { Link, useLocation } from 'react-router-dom';
import { IoIosArrowDown } from "react-icons/io";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { logout, setUser, setPermissions } from "../redux/features/authSlice";
import { useNavigate } from "react-router-dom";
import { FaBuilding } from 'react-icons/fa';
import { getAdminProfile } from "../redux/services/authService/authApi";
import { RiCloseLine } from "react-icons/ri";

import {
  MdDashboard,
  MdBusinessCenter,
  MdPeople,
  MdCampaign,
  MdReport,
  MdSettings,
  MdLogout,
  MdSports,
  MdApartment,
} from "react-icons/md";

import logo from '../assets/image/logo.jpeg';

const Sidebar = ({ isOpen, onToggleSidebar }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state.auth.user);
  const userPermissions = useSelector((state) => state.auth.permissions || []);
  const token = Cookies.get("adminToken");

  const [isLoadingProfile, setIsLoadingProfile] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeMenu, setActiveMenu] = useState(() => {
    return localStorage.getItem("activeMenu") || "";
  });

  // Check if it's mobile/tablet view
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fetch profile if needed
  useEffect(() => {
    const fetchProfile = async () => {
      if (user || !token) return;

      try {
        setIsLoadingProfile(true);
        const response = await getAdminProfile();

        if (response.success === 1 && response.data) {
          const userData = response.data;

          dispatch(setUser({
            id: userData.id,
            name: userData.name,
            email: userData.email,
            mobile: userData.mobile,
            role: userData.role || 'sub_admin',
            waad_id: userData.waad_id,
            waad_name: userData.waad_name,
            status: userData.status,
          }));

          if (userData.permissions) {
            dispatch(setPermissions(userData.permissions));
          }
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
        const tokenUser = getUserFromToken();
        if (tokenUser) {
          dispatch(setUser({
            id: tokenUser.id,
            email: tokenUser.email,
            role: tokenUser.role || 'sub_admin',
            waad_id: tokenUser.waad_id,
            waad_name: tokenUser.waad_name,
            name: tokenUser.name || "Admin",
          }));
        }
      } finally {
        setIsLoadingProfile(false);
      }
    };

    fetchProfile();
  }, [token, dispatch, user]);

  const getUserFromToken = () => {
    if (!token) return null;
    try {
      const decoded = JSON.parse(atob(token.split(".")[1]));
      return {
        id: decoded.id,
        email: decoded.email,
        role: decoded.role || 'sub_admin',
        waad_id: decoded.waad_id,
        waad_name: decoded.waad_name,
        name: decoded.name || "Admin",
      };
    } catch (err) {
      return null;
    }
  };

  const getUserRole = () => {
    if (user?.role) return user.role;
    const tokenUser = getUserFromToken();
    return tokenUser?.role || 'sub_admin';
  };

  const userRole = getUserRole();

  const hasViewPermission = (permissionKey) => {
    if (userRole === 'admin') return true;
    if (userRole === 'sub_admin') {
      return userPermissions.some(
        (p) => p.permission_key === permissionKey && p.can_view === 1
      );
    }
    return false;
  };

  const hasChildViewPermission = (children) => {
    if (!children?.length) return false;
    return children.some((child) => hasViewPermission(child.permission));
  };

  const menuItems = [
    {
      items: [
        {
          id: 'dashboard',
          title: 'Dashboard',
          href: '/',
          icon: <MdDashboard />,
          permission: 'dashboard',
        },
        {
          id: 'admin-management',
          title: 'Admin Management',
          dropdown: true,
          icon: <MdBusinessCenter />,
          children: [
            {
              id: 'admin-list',
              title: 'Admin List',
              href: '/admin-list',
              permission: 'admin_list',
            },
          ],
        },
        {
          id: 'master-management',
          title: 'Master Management',
          dropdown: true,
          icon: <MdPeople />,
          children: [
            { id: 'gotra', title: 'Gotra', href: '/gotra-list', permission: 'gotra_list' },
            { id: 'nanihal-gotra', title: 'Nanihal Gotra', href: '/nanihal-gotra', permission: 'nanihal_gotra_list' },
            { id: 'kuldevi', title: 'Kuldevi', href: '/kuldevi', permission: 'kuldevi_list' },
            { id: 'education', title: 'Education', href: '/education', permission: 'education_list' },
            { id: 'occupation', title: 'Occupation', href: '/occupation', permission: 'occupation_list' },
            { id: 'waad', title: 'Waad List', href: '/waad', permission: 'waad_list' },
            { id: 'gaon', title: 'Gaon List', href: '/gaon', permission: 'gaon_list' },
          ],
        },
        {
          id: "familymanagement",
          title: "Pariwar Management",
          dropdown: true,
          icon: <MdPeople />,
          children: [
            { id: "pendingPariwar", title: "Pending Pariwar", href: "/pariwar-pending", permission: 'pariwar_pending' },
            { id: "approvedPariwar", title: "Approved Pariwar", href: "/pariwar-success", permission: 'pariwar_approved' },
            { id: "rejectedPariwar", title: "Rejected Pariwar", href: "/pariwar-rejected", permission: 'pariwar_rejected' },
          ],
        },
        {
          id: "mamberymanagement",
          title: "Sadasya Management",
          dropdown: true,
          icon: <MdPeople />,
          children: [
            { id: "pendingSadasya", title: "Pending Sadasya", href: "/sadasya-pending", permission: 'sadasya_pending' },
            { id: "approvedSadasya", title: "Approved Sadasya", href: "/sadasya-success", permission: 'sadasya_approved' },
            { id: "rejectedSadasya", title: "Rejected Sadasya", href: "/sadasya-rejected", permission: 'sadasya_rejected' },
          ],
        },
        {
          id: 'building-management',
          title: 'Building Management',
          dropdown: true,
          icon: <FaBuilding />,
          children: [
            { id: 'all-buildings', title: 'All Buildings', href: '/admin/buildings', permission: 'building_list' },
            { id: 'all-bookings', title: 'All Bookings', href: '/admin/bookings', permission: 'booking_list' },
          ],
        },
        {
          id: 'education-sco',
          title: 'Scholarships',
          href: '/admin/education',
          icon: <MdCampaign />,
          permission: 'scholarship_list',
        },
        {
          id: 'eventmanagement',
          title: 'Event Management',
          href: '/events',
          icon: <MdCampaign />,
          permission: 'event_list',
        },
        {
          id: 'newsmanagement',
          title: 'News Management',
          href: '/news',
          icon: <MdCampaign />,
          permission: 'news_list',
        },
        {
          id: 'helpdesk',
          title: 'Helpdesk',
          href: '/helpdesk',
          icon: <MdReport />,
          permission: 'helpdesk_list',
        },
        {
          id: 'employment',
          title: 'Employment',
          href: '/employment',
          icon: <MdReport />,
          permission: 'employment_list',
        },
        {
          id: 'selections',
          title: 'Selections',
          href: '/selections',
          icon: <MdSports />,
          permission: 'selections_list',
        },
        {
          id: 'content-setting',
          title: 'Content / Setting',
          href: '/web-setting',
          icon: <MdSettings />,
          permission: 'settings_view',
        },
        {
          id: 'banner',
          title: 'Banner',
          href: '/banner-list',
          icon: <MdSettings />,
          permission: 'banner_list',
        },
        {
          id: 'logout',
          title: 'Logout',
          action: "logout",
          icon: <MdLogout />,
        },
      ],
    },
  ];

  const getFilteredMenuItems = () => {
    return menuItems.map((section) => ({
      ...section,
      items: section.items.filter((item) => {
        if (item.action === 'logout') return true;
        if (item.href) return hasViewPermission(item.permission);
        if (item.dropdown && item.children) return hasChildViewPermission(item.children);
        return true;
      }),
    }));
  };

  const filteredMenuItems = getFilteredMenuItems();

  const handleLogout = () => {
    Cookies.remove("adminToken");
    dispatch(logout());
    navigate("/login");
    if (isMobile && isOpen) {
      onToggleSidebar();
    }
  };

  // Keep active menu + open correct dropdown on route change
  useEffect(() => {
    filteredMenuItems.forEach((section) => {
      section.items.forEach((item) => {
        if (item.href === location.pathname) {
          setActiveMenu(item.id);
          setActiveDropdown(null);
          localStorage.setItem("activeMenu", item.id);
        }

        if (item.children) {
          item.children.forEach((child) => {
            if (child.href === location.pathname) {
              setActiveMenu(child.id);
              setActiveDropdown(item.id);
              localStorage.setItem("activeMenu", child.id);
            }
          });
        }
      });
    });
  }, [location.pathname]);

  const toggleDropdown = (dropdownId) => {
    // Simple toggle - if same dropdown, close it; if different, open it
    if (activeDropdown === dropdownId) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(dropdownId);
    }
  };

  const goTo = (id, href) => {
    setActiveMenu(id);
    localStorage.setItem("activeMenu", id);
    navigate(href);
    
    // Close sidebar on mobile after navigation
    if (isMobile) {
      setTimeout(() => {
        onToggleSidebar();
      }, 200);
    }
  };

  const renderMenuItem = (item) => {
    // Logout
    if (item.action === "logout") {
      return (
        <li key={item.id} className={`menu-item ${activeMenu === item.id ? "active" : ""}`}>
          <div className="menu-link" onClick={handleLogout}>
            {item.icon && <span className="menu-icon">{item.icon}</span>}
            <span className="menu-text">{item.title}</span>
          </div>
          <div className="sidebar-tooltip">
            <div className="tooltip-content">
              <strong>{item.title}</strong>
            </div>
          </div>
        </li>
      );
    }

    const isDropdownOpen = activeDropdown === item.id;
    const isActive = activeMenu === item.id ||
      (item.children && item.children.some((c) => c.id === activeMenu));

    return (
      <li
        key={item.id}
        className={`menu-item ${isActive ? "active" : ""} ${item.dropdown ? "has-dropdown" : ""}`}
      >
        {item.dropdown ? (
          <div
            className={`menu-link ${isActive ? "active" : ""}`}
            onClick={() => toggleDropdown(item.id)}
          >
            {item.icon && <span className="menu-icon">{item.icon}</span>}
            <span className="menu-text">{item.title}</span>
            <span className={`menu-arrow ${isDropdownOpen ? "rotate" : ""}`}>
              <IoIosArrowDown />
            </span>
          </div>
        ) : (
          <div
            className={`menu-link ${activeMenu === item.id ? "active" : ""}`}
            onClick={() => goTo(item.id, item.href)}
          >
            {item.icon && <span className="menu-icon">{item.icon}</span>}
            <span className="menu-text">{item.title}</span>
          </div>
        )}

        {/* Hover tooltip */}
        <div className="sidebar-tooltip">
          <div className="tooltip-content">
            <strong>{item.title}</strong>
            {item.dropdown && (
              <ul className="tooltip-menu">
                {item.children
                  .filter((child) => userRole === 'admin' || hasViewPermission(child.permission))
                  .map((child) => (
                    <li key={child.id} onClick={() => {
                      goTo(child.id, child.href);
                    }}>
                      {child.title}
                    </li>
                  ))}
              </ul>
            )}
          </div>
        </div>

        {/* Inline submenu - always show when dropdown is open */}
        {item.dropdown && isDropdownOpen && (
          <div className="collapse show">
            <ul className="sub-menu">
              {item.children.map((child) => {
                if (userRole === 'sub_admin' && !hasViewPermission(child.permission)) {
                  return null;
                }
                return (
                  <li key={child.id} className={`menu-item ${activeMenu === child.id ? "active" : ""}`}>
                    <div
                      className={`menu-link ${activeMenu === child.id ? "active" : ""}`}
                      onClick={() => {
                        goTo(child.id, child.href);
                      }}
                    >
                      <span className="menu-text">{child.title}</span>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </li>
    );
  };

  if (isLoadingProfile) {
    return (
      <div className={`sidebar ${!isOpen ? 'closed' : ''}`}>
        <div className={`main-menu ${isOpen ? '' : 'collapsed'}`}>
          <div className="logo-box">
            <Link className="logo-link" to="/">
              <img src={logo} alt="logo" className="logo-full" height="40" />
              <MdApartment className="logo-icon" />
            </Link>
          </div>
          <div className="sidebar-content text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2 text-muted">Loading profile...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`sidebar ${!isOpen ? 'closed' : ''}`}>
      {!isOpen && <div className="overlaysidebar" onClick={onToggleSidebar}></div>}
      <div className={`main-menu ${isOpen ? '' : 'collapsed'}`}>
        <button
          className="overlay-close-btn"
          onClick={(e) => {
            e.stopPropagation();
            onToggleSidebar();
          }}
        >
          <RiCloseLine />
        </button>
        <div className="logo-box">
          <Link className="logo-link" to="/" onClick={() => {
            if (isMobile && isOpen) {
              onToggleSidebar();
            }
          }}>
            <img src={logo} alt="logo" className="logo-full" height="40" />
            <MdApartment className="logo-icon" />
          </Link>
        </div>

        <div className="sidebar-content">
          <ul className="app-menu">
            {filteredMenuItems.map((section, index) => (
              <React.Fragment key={index}>
                {section.items.map((item) => renderMenuItem(item))}
              </React.Fragment>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;